import { MathJax } from 'better-react-mathjax';
import React, { useEffect, useRef, useState } from 'react';

import { Formula } from 'shared/types';

interface Props {
  formula: Formula;
  isInputDisabled: boolean;
  changeFormikMathFormula: (currentFormula: Formula) => void;
}

export const StudentMathFormula = ({ formula, changeFormikMathFormula, isInputDisabled }: Props) => {
  const [width, setWidth] = useState(formula.answer?.length);
  const spanRef = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    if (spanRef !== null && spanRef.current) {
      setWidth(spanRef.current.offsetWidth + 5);
    }
  }, [formula.answer]);

  return (
    <div className="flex">
      <MathJax>{formula.formula.split('?')[0] + '`'}</MathJax>

      <span
        ref={spanRef}
        className="absolute -z-50 inline-block !border-0 px-3 opacity-0"
        style={{ whiteSpace: 'pre' }}
      >
        {formula.answer}
      </span>

      <input
        type="text"
        style={{ width }}
        value={formula.answer}
        onChange={event => changeFormikMathFormula({ ...formula, answer: event.target.value })}
        className="min-w-1 !border-x-0 !border-b-2 !border-t-0 border-black bg-transparent px-3 text-center text-lg font-medium leading-[25px] outline-none lg:text-xl"
        maxLength={4}
        disabled={isInputDisabled}
      />

      {formula.formula.split('?')[1].length > 1 && <MathJax>{'`' + formula.formula.split('?')[1]}</MathJax>}
    </div>
  );
};
